import React from 'react';
import { ForecastCommentary } from '@rti/shared';

interface CommentaryPanelProps {
  forecastCommentary: ForecastCommentary[];
  allExpanded: boolean;
  onToggleCommentary: (item: ForecastCommentary) => void;
  onToggleAllCommentary: () => void;
}

const CommentaryPanel: React.FC<CommentaryPanelProps> = ({
  forecastCommentary,
  allExpanded,
  onToggleCommentary,
  onToggleAllCommentary
}) => {
  return (
    <div data-tour="forecast-commentary" className="row-span-2 bg-rs-off-black rounded-lg p-5">
      <h3 className="text-xl text-center mb-4 font-medium text-rs-off-white">
        Quarterly Forecast Insights
      </h3>

      <button
        data-tour="forecast-expand-all"
        className="bg-rs-green !text-black px-4 py-2 rounded hover:bg-rs-green/80 transition-colors"
        onClick={onToggleAllCommentary}
      >
        {allExpanded ? 'Collapse All' : 'Expand All'}
      </button>

      <div className="divide-y divide-rs-jet-light my-3">
        {forecastCommentary.map((item, index) => (
          <div key={index} className="py-3 cursor-pointer" onClick={() => onToggleCommentary(item)}>
            <div className="flex items-center justify-between text-sm font-semibold text-rs-dark-green">
              <span className="text-lg">
                Q{item.forecastQtr} {item.forecastYear}
                <span className="ml-2 text-base text-rs-off-white font-light"></span>
              </span>
              <span className="material-symbols-outlined text-base">
                {item.expanded ? 'do_not_disturb_on' : 'add_circle'}
              </span>
            </div>
            {item.expanded && (
              <div className="my-3 text-base text-rs-off-white leading-relaxed">
                <div dangerouslySetInnerHTML={{ __html: item.commentary }} />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CommentaryPanel;
